import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export const selectActiveInfrastructureTypes = (state: TApplicationState) => state.infrastructure.activeTypes;
